<template>
  <div class="able-mosaic" role="group" aria-label="Paralympic sport in Kenya">
    <figure
      class="able-mosaic__cell able-mosaic__cell--basketball"
      :style="{ backgroundImage: `url(${basketballSrc})` }"
    >
      <img :src="basketballSrc" alt="Wheelchair basketball training" loading="lazy" decoding="async" />
      <figcaption class="able-mosaic__caption">
        <i class="fa-solid fa-basketball" aria-hidden="true" />
        Wheelchair basketball
      </figcaption>
    </figure>

    <figure
      class="able-mosaic__cell able-mosaic__cell--runner"
      :style="{ backgroundImage: `url(${runnerSrc})` }"
    >
      <img :src="runnerSrc" alt="Paralympic track athlete" loading="lazy" decoding="async" />
      <figcaption class="able-mosaic__caption">
        <i class="fa-solid fa-person-running" aria-hidden="true" />
        Track &amp; field
      </figcaption>
    </figure>

    <figure
      class="able-mosaic__cell able-mosaic__cell--racer"
      :style="{ backgroundImage: `url(${racerSrc})` }"
    >
      <img :src="racerSrc" alt="Adaptive racing and mobility sport" loading="lazy" decoding="async" />
      <figcaption class="able-mosaic__caption">
        <i class="fa-solid fa-flag-checkered" aria-hidden="true" />
        Racing &amp; mobility sport
      </figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  name: "AbleGalleryGrid",
  props: {
    basketballSrc: { type: String, required: true },
    runnerSrc: { type: String, required: true },
    racerSrc: { type: String, required: true },
  },
};
</script>

<style scoped>
.able-mosaic {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: minmax(220px, 1fr) minmax(220px, 1fr) minmax(160px, 0.75fr);
  gap: clamp(10px, 2vw, 16px);
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: clamp(420px, 55vw, 560px);
}

.able-mosaic__cell {
  position: relative;
  margin: 0;
  border-radius: clamp(12px, 2vw, 18px);
  overflow: hidden;
  background-color: #111;
  background-size: cover;
  background-position: center;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.14);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.able-mosaic__cell:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.2);
}

.able-mosaic__cell img {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.able-mosaic__cell--basketball {
  grid-column: 1;
  grid-row: 1 / 3;
}

.able-mosaic__cell--runner {
  grid-column: 2;
  grid-row: 1 / 3;
}

.able-mosaic__cell--racer {
  grid-column: 1 / -1;
  grid-row: 3;
  min-height: clamp(140px, 22vw, 200px);
}

.able-mosaic__caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  font-size: clamp(0.82rem, 1.6vw, 0.95rem);
  font-weight: 700;
  color: #fff;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.78));
}

.able-mosaic__caption i {
  color: #ffdd57;
}

@media (min-width: 900px) {
  .able-mosaic {
    grid-template-columns: 1.05fr 1.05fr 1.35fr;
    grid-template-rows: 1fr 1fr;
    min-height: 480px;
  }

  .able-mosaic__cell--basketball {
    grid-column: 1;
    grid-row: 1 / 3;
  }

  .able-mosaic__cell--runner {
    grid-column: 2;
    grid-row: 1 / 3;
  }

  .able-mosaic__cell--racer {
    grid-column: 3;
    grid-row: 1 / 3;
  }
}

@media (max-width: 540px) {
  .able-mosaic {
    grid-template-columns: 1fr;
    grid-template-rows: 240px 240px 180px;
    min-height: auto;
  }

  .able-mosaic__cell--basketball,
  .able-mosaic__cell--runner,
  .able-mosaic__cell--racer {
    grid-column: 1;
    grid-row: auto;
  }
}
</style>
